import Keyring from "@polkadot/keyring";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import routes from "../../../constants/routes";
import useConnectWs from "../../../hooks/useConnectWs";
import { setPopupMessage } from "../../../redux/popupMessage";
import { formatNumber } from "../../../utils/Helpers";
import { checkAddress } from "@polkadot/util-crypto";
import { showBalanceWithSpanLayout2, convertAmountWithDecimals } from "../../../utils/Helpers";
import metadata from "../../../contract/metadata.json";
import { ContractPromise } from "@polkadot/api-contract";

const SendToken = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  formatNumber();
  const [accountInfo, setAccountInfo] = useState(null);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [api, setApi] = useConnectWs();
  const [toAddress, setToAddress] = useState(null);
  const [toMemo, setToMemo] = useState(null);
  const [amount, setAmount] = useState(0);
  const [pairMe, setPairMe] = useState(null);
  const [keyring, setkeyring] = useState(null);
  const history = useNavigate();
  const [balanceVBI, setBalanceVBI] = useState(0);
  const [feeVBI, setFeeVBI] = useState(0);
  const [token, setToken] = useState({
    token_name: "",
    short_name: "",
    token_contract: "",
    balance: 0,
    balanceAfterTX: 0,
  });
  const [contract, setContract] = useState(null);
  const from = "5GrwvaEF5zXb26Fz9rcQpDWS57CtERHpNehXCPcNoHGKutQY";

  const { account, mnemonic } = useSelector((state) => state.account);

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const gasLimit = 100000n * 1000000n;
  const storageDepositLimit = null;

  useEffect(() => {
    let symbol = "VBI";
    if (params.get("symbol") != "") {
      symbol = params.get("symbol");
    }
    setToken((prev) => ({
      ...prev,
      short_name: symbol,
      token_contract: params.get("address"),
    }));
  }, []);

  useEffect(() => {
    if (
      api &&
      token &&
      token.short_name != "VBI" &&
      token.token_contract &&
      token.token_contract != ""
    ) {
      const contract = new ContractPromise(api, metadata, token.token_contract);
      setContract(contract);
    }
  }, [api, token]);

  useEffect(() => {
    (async function () {
      if (token.short_name != "" && accountInfo) {
        var balance = 0;

        if (token.short_name == "VBI") {
          balance = accountInfo?.data?.free?.toString();
        } else {
          if (api && token && account && contract) {
            const target = account?.address;
            const callValue = await contract.query.balanceOf(from, { gasLimit: -1 }, target);
            balance = callValue.output.toString();
          }
        }

        setToken((prev) => ({
          ...prev,
          balance: balance,
          balanceAfterTX: balance,
        }));
      }
    })();
  }, [accountInfo]);

  useEffect(() => {
    const _keyring = new Keyring({ type: "sr25519" });
    setkeyring(_keyring);
    const _pairMe = _keyring.addFromUri(mnemonic);
    setPairMe(_pairMe);
  }, [mnemonic]);

  useEffect(() => {
    if (!account) {
      history(routes?.dashboard);
    }
  }, [account]);

  useEffect(() => {
    if (account && api) {
      (async function () {
        var accountInfo = await api.query.system.account(account?.address);
        setAccountInfo(accountInfo);
        api.query.system.account.multi([account?.address], (balances) => {
          setLoadingRequest(false);
          setAccountInfo((prev) => ({
            ...prev,
            data: {
              ...prev.data,
              free: balances.map(({ data: { free } }) => free)[0],
            },
          }));

          setBalanceVBI(accountInfo?.data?.free.toString());
        });
      })();
    }
  }, [account, api]);

  useEffect(() => {
    if (api && account && pairMe && toAddress && amount > 0) {
      (async function () {
        var partialFee = 0;
        var amountSend = convertAmountWithDecimals(amount).toFixed(0);
        if (token.short_name == "VBI") {
          const info = await api.tx.balances
            .transfer(toAddress, amountSend)
            .paymentInfo(pairMe.address);
          //         console.log(`
          //   class=${info.class.toString()},
          //   weight=${info.weight.toString()},
          //   partialFee=${info.partialFee.toHuman()}
          // `);
          partialFee = info.partialFee.toString();
        } else {
          const info = await contract.tx
            .transfer({ gasLimit, storageDepositLimit }, toAddress, amountSend)
            .paymentInfo(pairMe.address);
          //   console.log(`
          //   contract transfer class=${info.class.toString()},
          //     weight=${info.weight.toString()},
          //     partialFee=${info.partialFee.toHuman()}
          //   `);
          partialFee = info.partialFee.toString();
        }

        setFeeVBI(partialFee);

        var balanceAfterTX = token.balance - amountSend;
        setToken((prev) => ({
          ...prev,
          balanceAfterTX: balanceAfterTX,
        }));
        if (balanceAfterTX < 0) {
          dispatch(setPopupMessage(t("sendToken.Amount Less Balance")));
        }
        if (Number(partialFee) > Number(balanceVBI)) {
          dispatch(setPopupMessage(t("sendToken.Not enough VBI as fee")));
        }
      })();
    }
    if (amount < 0) {
      dispatch(setPopupMessage(t("sendToken.Invalid Amount")));
    }
  }, [amount, toAddress]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const check = checkAddress(toAddress, 42);
    if (!check[0]) {
      dispatch(setPopupMessage(t("createToken.Invalid address")));
      return false;
    }

    if (mnemonic == null) {
      dispatch(setPopupMessage(t("createToken.Invalid mnemonic")));
      return false;
    }

    if (amount <= 0) {
      dispatch(setPopupMessage(t("createToken.Invalid amount")));
      return false;
    }

    if (token.balanceAfterTX < 0) {
      dispatch(setPopupMessage(t("sendToken.Amount Less Balance")));
      return false;
    }
    if (Number(feeVBI) > Number(balanceVBI)) {
      dispatch(setPopupMessage(t("sendToken.Not enough VBI as fee")));
      return false;
    }

    setLoadingRequest(true);

    const { nonce } = await api.query.system.account(pairMe.address);
    var amountSend = convertAmountWithDecimals(amount).toFixed(0);

    if (token.short_name == "VBI") {
      // Sign and send a transfer
      const txHash = await api.tx.balances
        .transfer(toAddress, amountSend)
        .signAndSend(pairMe, { nonce }, ({ events = [], status }) => {
          console.log("Transaction status:", status.type);
          dispatch(setPopupMessage("Transaction status:" + status.type));

          if (status.isInBlock) {
            console.log("Included at block hash", status.asInBlock.toHex());
            console.log("Events:");

            events.forEach(({ event: { data, method, section }, phase }) => {
              console.log("\t", phase.toString(), `: ${section}.${method}`, data.toString());
            });
          } else if (status.isFinalized) {
            console.log("Finalized block hash", status.asFinalized.toHex());

            setLoadingRequest(false);
            setAmount(0);
            dispatch(setPopupMessage("Successfully"));
          }
        });
    } else {
      console.log("transfer", toAddress, amountSend);
      await contract.tx
        .transfer({ gasLimit, storageDepositLimit }, toAddress, amountSend)
        .signAndSend(pairMe, { nonce }, ({ events = [], status }) => {
          console.log("contract Transaction status:", status.type);
          dispatch(setPopupMessage("Transaction status:" + status.type));

          if (status.isInBlock) {
            console.log("Included at block hash", status.asInBlock.toHex());
            console.log("Events:");

            events.forEach(({ event: { data, method, section }, phase }) => {
              console.log("\t", phase.toString(), `: ${section}.${method}`, data.toString());
            });
          } else if (status.isFinalized) {
            console.log("Finalized block hash", status.asFinalized.toHex());

            setLoadingRequest(false);
            setAmount(0);
            dispatch(setPopupMessage("Successfully"));
          }
        });
    }
  };

  console.log("pairMe ", pairMe);

  return (
    <div className="pages-createToken3">
      <div className="box">
        <div className="top">
          <div className="left">{t("sendToken.Title")}</div>
          <Link to={routes.wallet} className="right g-buttonHover">
            {t("createToken.Back")}
          </Link>
        </div>
        <form action={routes.createToken4} onSubmit={handleSubmit}>
          <div className="formGroup">
            <label>Send from account</label>
            <input disabled value={account?.address} required />
          </div>
          <div className="formGroup">
            <label>Recipient</label>
            <input onChange={(e) => setToAddress(e.target.value)} required />

            <div className="info">
              <img src="/images/info.svg" alt="" />
              <div className="text">{t("createToken.tooltipTokenDecimal")}</div>
            </div>
          </div>
          <div className="formGroup">
            <label>Amount</label>
            <input
              type="number"
              onChange={(e) => setAmount(e.target.value)}
              required
              value={amount}
            />
            <div className="unit">{token.short_name}</div>
          </div>
          <div className="formGroup">
            <label>Memo (optional)</label>
            <input onChange={(e) => setToMemo(e.target.value)} />
            <div className="info">
              <img src="/images/info.svg" alt="" />
              <div className="text">{t("createToken.tooltipTokenDecimal")}</div>
            </div>
          </div>

          <div className="walletInfo">
            <div className="row">
              <div className="left">Fee</div>
              <div
                className="right"
                dangerouslySetInnerHTML={{
                  __html: showBalanceWithSpanLayout2(feeVBI) + " VBI",
                }}
              ></div>
            </div>
            <div className="row">
              <div className="left">Balance</div>
              <div
                className="right"
                dangerouslySetInnerHTML={{
                  __html: showBalanceWithSpanLayout2(token.balance) + " " + token.short_name,
                }}
              ></div>
            </div>
            <div className="row">
              <div className="left">Balance after tx</div>
              <div
                className="right"
                dangerouslySetInnerHTML={{
                  __html: showBalanceWithSpanLayout2(token.balanceAfterTX) + " " + token.short_name,
                }}
              ></div>
            </div>
          </div>

          <button disabled={loadingRequest} className="submit g-buttonHover">
            {loadingRequest ? "Sending" : "Send token"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SendToken;
